import { useMemo } from 'react';

import { usePrevious } from '@hsp/react-hooks';

import { useTableStoreSelector } from 'components/table/hooks/context';

export const usePageChanged = () => {
  const page = useTableStoreSelector((state) => state.page);
  const pageSize = useTableStoreSelector((state) => state.pageSize);
  const previousPage = usePrevious(page);
  const previousPageSize = usePrevious(pageSize);
  const total = useTableStoreSelector((state) => state.total);

  const hasPageChanged = page !== previousPage;
  const hasPageSizeChanged = pageSize !== previousPageSize;

  return useMemo(() => {
    if ((!hasPageChanged && !hasPageSizeChanged) || total === 0) {
      return null;
    }

    return {
      pageIndex: page,
      pageSize,
      previousPageIndex: previousPage ?? page,
      total,
    } as const;
  }, [hasPageChanged, hasPageSizeChanged, page, pageSize, previousPage, total]);
};
